import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { format } from "date-fns";
import { StudentSemesterAttestationResponse } from "../../models/dtos";
import { confirmPopup } from "primereact/confirmpopup";

interface AttestationsTableProps {
  attestations: StudentSemesterAttestationResponse[];
  onEditAttestation: (attestation: StudentSemesterAttestationResponse) => void;
  onDeleteAttestation: (attestationId: number) => void;
}

const AttestationsTable = ({ attestations, onEditAttestation, onDeleteAttestation }: AttestationsTableProps) => {
  const handleDelete = (event: React.MouseEvent, attestation: StudentSemesterAttestationResponse) => {
    confirmPopup({
      target: event.currentTarget as HTMLElement,
      message: 'Сигурни ли сте, че искате да изтриете тази заверка?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => onDeleteAttestation(attestation.studentSemesterAttestationId),
    });
  };

  const actionsTemplate = (rowData: StudentSemesterAttestationResponse) => (
    <div className="flex gap-2">
      <Button
        icon="pi pi-pencil"
        className="p-button-rounded p-button-text"
        onClick={() => onEditAttestation(rowData)}
      />
      <Button
        icon="pi pi-trash"
        className="p-button-rounded p-button-text p-button-danger"
        onClick={(e) => handleDelete(e, rowData)}
      />
    </div>
  );

  return (
    <DataTable value={attestations} className="mt-3" emptyMessage="Няма намерени заверки">
      <Column field="semester" header="Семестър" />
      <Column field="academicYearName" header="Учебна година" />
      <Column
        field="attestationDate"
        header="Дата на заверка"
        body={(rowData) =>
          rowData.attestationDate ? format(new Date(rowData.attestationDate), "dd.MM.yyyy") : ""
        }
      />
      <Column field="semesterAttestationTypeName" header="Тип заверка" />
      <Column body={actionsTemplate} style={{ width: '8rem' }} />
    </DataTable>
  );
};

export default AttestationsTable; 
